import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';

@Injectable()
export class SaleItemService {

  constructor(
                private http: HttpClient,
                private global: GlobalDataService
             ) { }


  searchProductByAttribut(attributes: {}){
        return this.http.get(this.global.httpUrl+"product-storage?name="+attributes['name']);
  }

  addToSaleCartService(data: any){
        return this.http.post(this.global.httpUrl+"sales-cart/items", data);
  }

  updateSaleCartService(data: any,id: any){
        return this.http.put(this.global.httpUrl+"sales-cart/items/"+id, data);
  }

  getSaleCartItemsBySalesId(id: any){
        return this.http.get(this.global.httpUrl+"sales-cart/items?sales_cart_id="+id);
  }

  deleteSaleCartItemService(id: any){
        return this.http.delete(this.global.httpUrl+"sales-cart/items/"+id);
  }

  issueSaleInvoiceService(id: any,data: any){
        return this.http.post(this.global.httpUrl+"sales/"+id+'/move', data);
  }  

 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale-item.service.ts